// Garden info panel and auth UI

import { t } from '@/i18n'
import type { Garden } from '@/types'
import { VERSION } from '@/version'
import {
  authPanel,
  infoPanel,
  controlsHint,
  togglePanel,
  layerPanel,
  gardenNameEl,
  plantCountEl,
  buildingCountEl,
  appVersionEl
} from './elements'
import { getViewer } from './state'
import { updateViewToggle, updateLayerButtons } from './controls'
import { hideLoading } from './loading'
import { setTopBarGardenName, setTopBarGardenDescription } from './topBar'

/**
 * Show auth panel
 */
export function showAuth(): void {
  authPanel.classList.remove('hidden')
  hideLoading()
}

/**
 * Hide auth panel
 */
export function hideAuth(): void {
  authPanel.classList.add('hidden')
}

/**
 * Show main UI panels after garden loads
 */
export function showUI(): void {
  infoPanel.style.display = 'block'
  controlsHint.style.display = 'block'
  togglePanel.style.display = 'block'
  layerPanel.style.display = 'flex'
  updateViewToggle()
  updateLayerButtons()

  // Display version
  appVersionEl.textContent = `v${VERSION}`
}

/**
 * Update UI with garden data
 */
export function updateUI(garden: Garden): void {
  const name = garden.name || t('ui.defaultGardenName')
  gardenNameEl.textContent = name

  // Update top bar garden name + description
  setTopBarGardenName(name)
  setTopBarGardenDescription(garden.description || '')

  const viewer = getViewer()
  if (viewer) {
    const stats = viewer.getStats()
    plantCountEl.textContent = stats.plants.toString()
    buildingCountEl.textContent = stats.buildings.toString()
  }
}
